<style>
table.table-cells-180 th,
table.table-cells-180 td {
  min-width: 180px !important;
}

.rounded-bottom-0 {
  border-bottom-left-radius: 0rem !important;
  border-bottom-right-radius: 0rem !important;
}
</style>

<template>
  <div class="col-md-12">
    <div class="card border-bottom-0 rounded-bottom-0">
      <div class="card-header border-bottom-0">
        <h4 class="float-left d-none d-md-block">Händler Kalk</h4>
        <!-- Default switch s-->

        <button type="button" class="btn btn-primary ml-2 float-right" @click="save()">Speichern</button>

        <button
          type="button"
          class="btn btn-md btn-secondary ml-2 float-right"
          :disabled="pendingChanges"
          @click="switchMode()"
        >
          <span v-if="vendorOrMarketAccount == false">nach Lieferanten filtern</span>
          <span v-else>nach MarketAccount filtern</span>
        </button>

        <b-form-select
          v-if="vendorOrMarketAccount == false"
          class="float-right col-md-5 col-xl-4 col-sm-10"
          id="sctMarketAccount"
          :options="marketAccounts"
          :disabled="pendingChanges"
          v-model="currentlySelectedMarketAccountId"
        ></b-form-select>

        <b-form-select
          v-else
          class="float-right col-md-5 col-xl-4 col-sm-10"
          id="sctVendor"
          :options="vendors"
          v-model="currentlySelectedVendorId"
        ></b-form-select>

        <button
          v-if="vendorOrMarketAccount == false"
          type="button"
          class="btn btn-secondary btn-md mx-2 float-right"
          :disabled="pendingChanges"
          @click="popupCreateRule()"
        >
          <span class="icon icon-plus"></span>
        </button>
      </div>
    </div>

    <div v-bind:style="{ 'height': tHeight + 'px' }" class="border-right border-bottom">
      <vue-scrolling-table
        class="table-editable table table-hover table-sm table-cells-180"
        deadAreaColor="#FFF"
      >
        <template slot="thead">
          <tr>
            <th>
              <button type="button" class="btn btn-secondary btn-sm" @click="switchVendorSort()" :disabled="pendingChanges">
                <span v-if="sortAscendingOrDescending == 1" class="icon icon-sort-alpha-asc"></span>
                <span v-else class="icon icon-sort-alpha-desc"></span>
              </button>
              <span v-if="vendorOrMarketAccount">Market Account</span>
              <span v-else>Lieferant</span>
            </th>

            <th>max. Preis (Neu / SH)</th>
            <!-- Price Max -->
            <th>fix Aufschlag (Neu / SH)</th>
            <!-- Fixed Charge -->
            <th>min. Aufschlag in % (Neu / SH)</th>
            <!-- percentCharge[new/used]Min -->
            <th>max. Aufschlag in % (Neu / SH)</th>
            <!-- percentCharge[new/used]Max -->
            <th>Repricing-Puffer (Neu / SH)</th>
            <!-- percentCharge[new/used]Max -->
            <th>
              <div style="text-align: center;">min. Bestand</div>
            </th>
            <!-- repricingBufferNew/Used -->
            <th>Aktiv</th>
            <th>Actions</th>
          </tr>
        </template>

        <template slot="tbody">
          <tr
            v-for="(item, itr) in items"
            v-bind:class="{ 'table-info': (item.vendorId == popupCreateRuleVendorId) }"
            v-bind:key="item.id"
          >
            <td>
              <div>
                <b v-if="vendorOrMarketAccount == false">{{passedVendors[item.vendorId]}}</b><!-- by Vendor -->
                <b v-else>{{passedMarketAccounts[item.marketAccountId]}}</b>
              </div>
            </td>
            <td>
              <!-- Price Max -->
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  style="text-align: right;"
                  class="form-control"
                  required
                  v-model="item.priceMaxNew"
                />
                <div class="input-group-append mb-auto">
                  <span class="input-group-text" style="width: 64px">€ (Neu)</span>
                </div>
              </div>
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  style="text-align: right;"
                  class="form-control"
                  required
                  v-model="item.priceMaxUsed"
                />
                <div class="input-group-append mb-auto">
                  <span class="input-group-text" style="width: 64px">€ (SH)</span>
                </div>
              </div>
            </td>

            <td>
              <!-- Fixed Charge -->
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  style="text-align: right;"
                  class="form-control"
                  required
                  v-model="item.fixedChargeNew"
                />
                <div class="input-group-append mb-auto">
                  <span class="input-group-text" style="width: 64px">€ (Neu)</span>
                </div>
              </div>
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  style="text-align: right;"
                  class="form-control"
                  required
                  v-model="item.fixedChargeUsed"
                />
                <div class="input-group-append mb-auto">
                  <span class="input-group-text" style="width: 64px">€ (SH)</span>
                </div>
              </div>
            </td>

            <td>
              <!-- percentCharge[new/used]Min -->
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  style="text-align: right;"
                  class="form-control"
                  required
                  v-model="item.percentChargeNewMin"
                />
                <div class="input-group-append mb-auto">
                  <span class="input-group-text" style="width: 64px">% (Neu)</span>
                </div>
              </div>
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  style="text-align: right;"
                  class="form-control"
                  required
                  v-model="item.percentChargeUsedMin"
                />
                <div class="input-group-append mb-auto">
                  <span class="input-group-text" style="width: 64px">% (SH)</span>
                </div>
              </div>
            </td>

            <td>
              <!-- percentCharge[new/used]Max -->
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  style="text-align: right;"
                  class="form-control"
                  required
                  v-model="item.percentChargeNewMax"
                />
                <div class="input-group-append mb-auto">
                  <span class="input-group-text" style="width: 64px">% (Neu)</span>
                </div>
              </div>
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  style="text-align: right;"
                  class="form-control"
                  required
                  v-model="item.percentChargeUsedMax"
                />
                <div class="input-group-append mb-auto">
                  <span class="input-group-text" style="width: 64px">% (SH)</span>
                </div>
              </div>
            </td>

            <td>
              <!-- repricingBufferNew/Used -->
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  style="text-align: right;"
                  class="form-control"
                  required
                  v-model="item.repricingBufferNew"
                />
                <div class="input-group-append mb-auto">
                  <span class="input-group-text" style="width: 64px">€ (Neu)</span>
                </div>
              </div>
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  style="text-align: right;"
                  class="form-control"
                  required
                  v-model="item.repricingBufferUsed"
                />
                <div class="input-group-append mb-auto">
                  <span class="input-group-text" style="width: 64px">€ (SH)</span>
                </div>
              </div>
            </td>

            <td>
              <!-- minStockQuantity -->
              <div class="input-group input-group-sm d-flex flex-row">
                <div class="d-flex justify-content-center">
                  <input
                    type="text"
                    style="text-align: center;"
                    class="form-control col-md-4"
                    required
                    v-model="item.minStockQuantity"
                  />
                </div>
              </div>
            </td>

            <td>
              <!-- isActive -->
              <input
                type="checkbox"
                class="form-control"
                value="1"
                required
                v-model="item.isActive"
              />
            </td>

            <td>
              <!-- delete Item Button -->
              <button type="button" class="btn btn-secondary btn-md" @click="deleteItem(itr)">
                <span class="icon icon-bin"></span>
              </button>
            </td>
          </tr>
        </template>
      </vue-scrolling-table>
    </div>

    <!-- vendor dialogue pop-up menu -->
    <div>
      <b-modal v-model="modalShow_createNewRule" centered>
        Bitte wählen sie einen Lieferanten aus:
        <b-form-select
          class="form-select form-select-sm"
          id="sctNewVendor"
          :options="_.omit(vendors, _.values(_.mapValues(items, function (item) {return item.vendorId;})))"
          v-model="popupCreateRuleVendorId"
        ></b-form-select>

        <!-- :value="_.first(_.values(_.mapValues(items, function (item) {return item.vendorId;})))" -->
        <div slot="modal-footer" class="w-100">
          <b-btn size="md" class="float-right" @click="setNewVendor()">Confirm</b-btn>
        </div>
      </b-modal>
    </div>

      <modal-error-component v-model="modalError"></modal-error-component>
  </div>
</template>

<script>
export default {
  props: ["passedVendors", "passedMarketAccounts"],
  data() {
    return {
      items: [],
      oldItems: [],
      changedItems: [],
      vendorOrMarketAccount: false,
      marketAccounts: this.passedMarketAccounts,
      vendors: this.passedVendors,
      currentlySelectedMarketAccountId: 1,
      currentlySelectedVendorId: 1,
      popupCreateRuleVendorId: -1,
      sortAscendingOrDescending: 1,
      sortAscendingOrDescendingWatchBlock: false, // prevents pendingChanges from triggering, if items are being resorted.
      modalShow_createNewRule: false,
      tHeight: window.innerHeight - 200,
      pendingChanges: false,
      modalError: {
        show: false,
        message: 'unpopulated',
        error: 'unpopulated',
        title: 'unpopulated'
      },
    };
  },

  watch: {
    currentlySelectedMarketAccountId: function() {
      this.loadItems();
    },
    currentlySelectedVendorId: function() {
      this.currentlySelectedVendorId = parseInt(this.currentlySelectedVendorId);
      this.loadItems();
    },
    items: {
      handler: function() {
        if(!this.sortAscendingOrDescendingWatchBlock) {
        this.pendingChanges = true;
        }else{
          this.sortAscendingOrDescendingWatchBlock = false;
        }
      },
      deep: true
    }
  },

  methods: {
    loadItems() {
      var uri = "/vendormarketaccount/";
      if (this.vendorOrMarketAccount == true) {
        uri += "itemsbyvendor/" + this.currentlySelectedVendorId;
      } else {
        uri += "itemsbymarketaccount/" + this.currentlySelectedMarketAccountId;
      }
      axios.get(uri).then(response => {
        this.items = response.data;
        this.oldItems = _.cloneDeep(this.items);
        this.sortItems(false);
        this.formatItems();
        Vue.nextTick(() => { //probably redundant because of sortItems containing pendingChanges switch already!
          this.pendingChanges = false;
        });
      }).catch((error) => {
        this.modalError = {
          show: true,
          message: 'Items konnten nicht geladen werden.',
          error: error,
          title: 'Market Accounts Laden'
        }
        
      });
    },

    switchMode() {
      this.vendorOrMarketAccount = !this.vendorOrMarketAccount;
      this.loadItems();
    },
    switchVendorSort() {
      this.sortAscendingOrDescending *= -1;
      this.sortItems(false);
    },
    errorWrapper(itemValue, item, name) {
      console.log("errorWrapper called for item: ");
      console.log(itemValue);
      this.modalError = {
        show: true,
        message: "Eingabe für " + name + " fehlerhaft: " + itemValue,
        error: JSON.stringify(item, null, 2),
        title: 'Validierung'
      };
    },
    validateItems() {
      const isNotNumeric  = x => (x.search(/[^0-9|.|-]/) != -1 || (x.split(".").length > 2) ||  x.search("-") > 0);
      const isNotIntegral = z => (z.search(/[^0-9]/) == -1);

      this.items.forEach((item) => {
        // convert everything to string if it is not. Validation assumes that 
        // all cells are strings, why I do not understand. (This was done because if creating new item, priceMaxNew 
        // and all other fields are integers, and Integer primitives do not have .replace() function, which causes a silent error!
        if(typeof item.priceMaxNew !== 'string') item.priceMaxNew = item.priceMaxNew.toString();
        if(typeof item.priceMaxUsed !== 'string') item.priceMaxUsed = item.priceMaxUsed.toString();
        if(typeof item.fixedChargeNew !== 'string') item.fixedChargeNew = item.fixedChargeNew.toString();
        if(typeof item.fixedChargeUsed !== 'string') item.fixedChargeUsed = item.fixedChargeUsed.toString();
        if(typeof item.percentChargeNewMin !== 'string') item.percentChargeNewMin = item.percentChargeNewMin.toString();
        if(typeof item.percentChargeNewMax !== 'string') item.percentChargeNewMax = item.percentChargeNewMax.toString();
        if(typeof item.percentChargeUsedMin !== 'string') item.percentChargeUsedMin = item.percentChargeUsedMin.toString();
        if(typeof item.percentChargeUsedMax !== 'string') item.percentChargeUsedMax = item.percentChargeUsedMax.toString();
        if(typeof item.repricingBufferNew !== 'string') item.repricingBufferNew = item.repricingBufferNew.toString();
        if(typeof item.repricingBufferUsed !== 'string') item.repricingBufferUsed = item.repricingBufferUsed.toString();

        item.priceMaxNew = item.priceMaxNew.replace(",", ".");
        item.priceMaxUsed = item.priceMaxUsed.replace(",", ".");
        item.fixedChargeNew = item.fixedChargeNew.replace(",", ".");
        item.fixedChargeUsed = item.fixedChargeUsed.replace(",", ".");
        item.percentChargeNewMin = item.percentChargeNewMin.replace(",", ".");
        item.percentChargeNewMax = item.percentChargeNewMax.replace(",", ".");
        item.percentChargeUsedMin = item.percentChargeUsedMin.replace(",", ".");
        item.percentChargeUsedMax = item.percentChargeUsedMax.replace(",", ".");
        item.repricingBufferNew = item.repricingBufferNew.replace(",", ".");
        item.repricingBufferUsed = item.repricingBufferUsed.replace(",", ".");

        if (isNotNumeric(item.priceMaxNew)) this.errorWrapper(item.priceMaxNew, item, 'max. Preis (Neu / SH)');
        if (isNotNumeric(item.priceMaxUsed)) this.errorWrapper(item.priceMaxUsed, item,  'priceMaxUsed');
		    if (isNotNumeric(item.fixedChargeNew)) this.errorWrapper(item.fixedChargeNew, item,  'fix Aufschlag (Neu / SH)');
        if (isNotNumeric(item.fixedChargeUsed)) this.errorWrapper(item.fixedChargeUsed, item, 'fixedChargeUsed');
        if (isNotNumeric(item.percentChargeNewMin)) this.errorWrapper(item.percentChargeNewMin, item, 'min. Aufschlag in % (Neu / SH)');
		    if (isNotNumeric(item.percentChargeNewMax)) this.errorWrapper(item.percentChargeNewMax, item, 'max. Aufschlag in % (Neu / SH)');
        if (isNotNumeric(item.percentChargeUsedMin)) this.errorWrapper(item.percentChargeUsedMin, item, 'percentChargeUsedMin');
        if (isNotNumeric(item.percentChargeUsedMax)) this.errorWrapper(item.percentChargeUsedMax, item, 'percentChargeUsedMax');
		    if (isNotNumeric(item.repricingBufferNew)) this.errorWrapper(item.repricingBufferNew, item, 'Repricing-Puffer (Neu / SH)');
		    if (isNotNumeric(item.repricingBufferUsed)) this.errorWrapper(item.repricingBufferUsed, item, 'repricingBufferUsed');
      });
    },

    save() {
      this.popupCreateRuleVendorId = -1;
      this.validateItems();
      this.checkForChanges();

      axios.post("/vendormarketaccount/createorupdate", this.items)
        .then(response => {
          this.loadItems();

          const propertyToFilter = this.vendorOrMarketAccount ? 'marketAccountId' : 'vendorId';
          const pluralPropertyToFilter = `${propertyToFilter}s`
          const IdForRecomputation = !this.vendorOrMarketAccount ? 'marketAccountId' : 'vendorId';

          let  request = {
              vendorOrMarketAccount: this.vendorOrMarketAccount,
              [IdForRecomputation] : this.vendorOrMarketAccount ? this.currentlySelectedVendorId : this.currentlySelectedMarketAccountId,
              [pluralPropertyToFilter] : this.changedItems.map(item => {return item[propertyToFilter]})
          }
          // console.log(request);

          axios.post("/vendormarketaccount/addrecomputation", request).then(() => {

            Vue.nextTick(() => {
              this.pendingChanges = false;
              this.changedItems = [];
            });
          }).catch(error => {
           this.modalError = {
              show: true,
              message: "Änderungen wurden aufgrund eines Fehlers verworfen.",
              error: error,
              title: 'Erstellen oder Update'
            };
        });
        }).catch(error => {
           this.modalError = {
              show: true,
              message: "Änderungen wurden aufgrund eines Fehlers verworfen.",
              error: error,
              title: 'Erstellen oder Update'
            };
        });
    },

    deleteItem(itr) {
      if (confirm("Wirklich löschen?")) {
        if (this.items[itr].id == null || this.items[itr].vendorId == -1) {
          this.items.splice(itr, 1);
        } else {
          axios.delete("/vendormarketaccount/delete/" + this.items[itr].id)
            .then(response => {
              this.items.splice(itr, 1);
              Vue.nextTick(() => {
                this.pendingChanges = false;
              });
            }).catch(error => {
              this.modalError = {
                show: true,
                message: "Löschvorgang ohne Erfolg.",
                error: error,
                title: 'Löschvorgang'
              };
            });
        }
      }
    },

    popupCreateRule() {
      this.popupCreateRuleVendorId = _.keys(
        _.omit(
          this.vendors,
          _.values(
            _.mapValues(this.items, function(item) {
              return item.vendorId;
            })
          )
        )
      )[0];
      this.modalShow_createNewRule = true;
    },

    setNewVendor() {
      if (
        //(the new vendorId is not in the list of already existing rules)
        _.find(
          _.omit(
            this.vendors,
            _.values(
              _.mapValues(this.items, function(item) {
                return item.vendorId;
              })
            )
          ),
          this.popupCreateRuleVendorId
        ) == -1
      ) {
        confirm(
          "Der ausgewählte Lieferant wurde bereits in die Kalkulationstabelle eingetragen. Bitte wählen Sie einen anderen Lieferanten aus oder brechen Sie den Vorgang ab."
        );
        this.modalShow_createNewRule = true;
        return;
      }
      this.createItem(this.popupCreateRuleVendorId);
      this.modalShow_createNewRule = false;
      this.pendingChanges = true;
      this.sortItems(true);
      return;
    },

    createItem(vendorId) {
      if (vendorId == -1) {
        return;
      }
      this.modalShow_createNewRule = false;
      this.items.push({
        id: null,
        priceMaxNew: 0,
        priceMaxUsed: 0,
        fixedChargeNew: 0,
        fixedChargeUsed: 0,
        percentChargeNewMax: 0,
        percentChargeNewMin: 0,
        percentChargeUsedMax: 0,
        percentChargeUsedMin: 0,
        repricingBufferNew: 0,
        repricingBufferUsed: 0,
        minStockQuantity: 0,
        itemNote: "",
        priority: 0,
        currentState: 0,
        lastUpdatetime: 0,
        lastUpdateReason: "",
        isActive: 0,
        vendorId: vendorId,
        marketAccountId: document.getElementById("sctMarketAccount").value
      });
    },

    sortItems(setPendingChanges = false) {
      this.sortAscendingOrDescendingWatchBlock = true;

      if(this.vendorOrMarketAccount == false) {
        this.items.sort(
          (v, w) => this.passedVendors[v.vendorId].localeCompare(this.passedVendors[w.vendorId])
                  * this.sortAscendingOrDescending
        );
      }else{
        this.items.sort(
          (v, w) => this.passedMarketAccounts[v.marketAccountId].localeCompare(this.passedMarketAccounts[w.marketAccountId])
                  * this.sortAscendingOrDescending
        );
      }

      Vue.nextTick(() => {
        this.pendingChanges = setPendingChanges;
      });
    },
    checkForChanges(){
      //checks each row for diffenreces that have been made
      this.items.forEach((item) => {

        const propertyToFilter = this.vendorOrMarketAccount ? 'marketAccountId' : 'vendorId';
        const oldItem = this.oldItems.find(oldItem => oldItem[propertyToFilter] === item[propertyToFilter]);
        const hasChanged = Object.keys(item).some(key => 
          item[key] !== oldItem[key] && item[propertyToFilter] === oldItem[propertyToFilter]
        )
          if (hasChanged) {
            if(!this.changedItems.some(cItem => cItem[propertyToFilter] === item[propertyToFilter])){
              this.changedItems.push(item);
              // console.log("item not found, pushing it: " + item[propertyToFilter]);
            } else {
              // console.log("item was found "  + item[propertyToFilter]);
              const changedItem = this.changedItems.find(
                changedItem => changedItem[propertyToFilter] === item[propertyToFilter]
              )
              // console.log("found Item: " + changedItem[propertyToFilter]);

              const changedItemIndex = this.changedItems.findIndex(cItem => cItem[propertyToFilter] === changedItem[propertyToFilter]);
              // console.log("index of changedItem " + changedItemIndex);
              this.changedItems[changedItemIndex] = item;
            }

          }
      })
    },
    formatItems() { //TODO
      // sanity check all input for all rules, (kill trailing zeros?)
      /*
					for(var itr in this.items)
					{
						var item = this.items[itr];
						if((item.priceMaxNew !== null) && (typeof item.priceMaxNew.replace === 'function'))				item.priceMaxNew 		= item.priceMaxNew			.replace(',', '.');
						if((item.priceMaxUsed !== null) && (typeof item.priceMaxUsed.replace === 'function'))			item.priceMaxUsed 		= item.priceMaxUsed			.replace(',', '.');
					}
				*/
    }
  },

  getNextVendorId() {
    //returns an unsused vendorId which is not included in the list of vendors
    for (var itr in this.vendors) {
      for (var k in this.items) {
        if (itr.value !== k.vendorId) {
          return itr.value;
        }
      }
    }
    return -1;
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.tHeight = window.innerHeight - 200;
      });
    });

    
    let dump = [];
    _.forIn(this.marketAccounts, function(value, key) {
      dump.push({
        value: parseInt(key),
        text: value
      });
    });

    dump.sort((a,b) => {
      return a.text.localeCompare( b.text);
    });
    this.marketAccounts = dump;
    let dump2 = [];
    _.forIn(this.vendors, function(value, key) {
      dump2.push({
        value: parseInt(key),
        text: value
      });
    });

    dump2.sort((a,b) => {
      return a.text.localeCompare( b.text);
    });
    this.vendors = dump2;
    this.loadItems();

  }
};
</script>
